module.exports = __webpack_public_path__ + "static/media/1POLICY24.dbcb2e38.jpg";